const formatAudioTime = function( seconds ) {
	if ( !Number.isFinite( seconds ) || seconds < 0 ) {
		return '00:00';
	}
	const m = Math.floor( seconds / 60 );
	const s = Math.floor( seconds % 60 );
	return String( m ).padStart( 2, '0' ) + ':' + String( s ).padStart( 2, '0' );
};

const initMemberAudioPlayer = function( $custom ) {
	const $wrap = $custom.closest( '.member-audio-track__player' );
	const audio = $wrap.find( '.js-member-audio-source' ).get( 0 );

	if ( !audio ) {
		return;
	}

	const $btn = $custom.find( '.js-member-audio-toggle' );
	const $playIcon = $custom.find( '.js-member-audio-icon-play' );
	const $pauseIcon = $custom.find( '.js-member-audio-icon-pause' );
	const $progress = $custom.find( '.js-member-audio-progress' );
	const $bar = $custom.find( '.js-member-audio-bar' );
	const $time = $custom.find( '.js-member-audio-time' );

	const labelPlay = $btn.data( 'labelPlay' ) || 'Play';
	const labelPause = $btn.data( 'labelPause' ) || 'Pause';

	const updateTimeText = function() {
		const current = formatAudioTime( audio.currentTime );
		const total = audio.duration && Number.isFinite( audio.duration )
			? formatAudioTime( audio.duration )
			: '00:00';
		$time.text( current + ' / ' + total );
	};

	const updateProgress = function() {
		const d = audio.duration;
		if ( Number.isFinite( d ) && d > 0 ) {
			$bar.css( 'width', ( ( audio.currentTime / d ) * 100 ) + '%' );
		} else {
			$bar.css( 'width', '0%' );
		}
		updateTimeText();
	};

	const setPlaying = function( playing ) {
		$custom.toggleClass( 'is-playing', playing );
		if ( playing ) {
			$playIcon.attr( 'hidden', '' );
			$pauseIcon.removeAttr( 'hidden' );
		} else {
			$playIcon.removeAttr( 'hidden' );
			$pauseIcon.attr( 'hidden', '' );
		}
		$btn.attr( 'aria-label', playing ? labelPause : labelPlay );
	};

	$btn.on( 'click', function() {
		if ( audio.paused ) {
			audio.play().catch( function() {} );
		} else {
			audio.pause();
		}
	} );

	$btn.on( 'keydown', function( e ) {
		if ( e.key === ' ' ) {
			e.preventDefault();
			$btn.trigger( 'click' );
		}
	} );

	$progress.on( 'click', function( e ) {
		const d = audio.duration;
		if ( !Number.isFinite( d ) || d <= 0 ) {
			return;
		}
		const rect = this.getBoundingClientRect();
		const pct = ( e.clientX - rect.left ) / rect.width;
		audio.currentTime = Math.min( Math.max( pct, 0 ), 1 ) * d;
		updateProgress();
	} );

	$( audio ).on( 'loadedmetadata timeupdate', updateProgress );
	$( audio ).on( 'play', function() {
		setPlaying( true );
	} );
	$( audio ).on( 'pause', function() {
		setPlaying( false );
		updateProgress();
	} );
	$( audio ).on( 'ended', function() {
		setPlaying( false );
		audio.currentTime = 0;
		$bar.css( 'width', '0%' );
		updateTimeText();
	} );

	setPlaying( false );
	updateProgress();
};

const initBlock = function( $block ) {
	$block.find( '.js-member-audio-custom' ).each( function() {
		initMemberAudioPlayer( $( this ) );
	} );

};

app.loadBlock( initBlock, 'hero-member', '.section-hero-member' );

if ( module.hot ) {
	module.hot.accept();
}
